// LivestreamPlayerContext.tsx
'use client'

import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import {useParams} from 'next/navigation'
import {getInfoPlayer} from '@/services/infoPlayer'

interface LivestreamPlayerContextProps {
  broadNo: string | undefined
  bId: string | undefined
  liveStreamData: any
  getInfoChannelLiveStreamData: () => void
}

const LivestreamPlayerContext = createContext<
  LivestreamPlayerContextProps | undefined
>(undefined)

export const LivestreamPlayerProvider: React.FC<{
  children: React.ReactNode
}> = ({children}) => {
  const [broadNo, setBroadNo] = useState<string>('0')
  const [bId, setbjId] = useState<string>()
  const [liveStreamData, setPlayerData] = useState<any>()
  const params = useParams<{bjId: string}>()
  const bjId = params.bjId as string
  const getInfoChannelLiveStreamData = useCallback(async () => {
    try {
      const data = new FormData()
      data.append('bid', bjId)
      const res = await getInfoPlayer({bjId, body: data})
      setBroadNo(res?.CHANNEL?.BNO)
      setbjId(res?.CHANNEL?.BJID)
      setPlayerData(res?.CHANNEL)
    } catch (error) {
      console.log(error)
    }
  }, [bjId])
  useEffect(() => {
    getInfoChannelLiveStreamData()
  }, [getInfoChannelLiveStreamData])

  const contextValue = useMemo(
    () => ({
      broadNo,
      bId,
      liveStreamData,
      getInfoChannelLiveStreamData,
    }),
    [broadNo, bId, liveStreamData, getInfoChannelLiveStreamData],
  )

  return (
    <LivestreamPlayerContext.Provider value={contextValue}>
      {children}
    </LivestreamPlayerContext.Provider>
  )
}

export const useLivestreamPlayer = (): LivestreamPlayerContextProps => {
  const context = useContext(LivestreamPlayerContext)
  if (!context) {
    throw new Error(
      'useLivestreamPlayer must be used within a LivestreamPlayerProvider',
    )
  }
  return context
}
